import { DEAL_TYPES, PROMO_CODE_TYPES } from '../../../../../services/exports/Constants';

export default {
  title: 'Særtilbud',
  view_more: 'Se mere',
  badges: {
    PROMO: 'Kampagne',
    DEAL: 'Tilbud',
    'FREE ITEM': 'Gratis vare',
    REWARDS: 'Belønninger',
  },
  deals: {
    [DEAL_TYPES.GOOGLE_REVIEW_PROGRAM]: {
      title: '+{{reward}} ekstra point',
      description: 'Giv os en anmeldelse på Google',
    },
    [DEAL_TYPES.SMART_PRICING_RULE]: {
      title: 'Særtilbud',
      description: 'Anvendes allerede automatisk',
    },
    buttons: {
      add: 'Tilføj',
      remove: 'Fjern',
      show_details: 'Vis detaljer',
    },
    mobile_app_signup_bonus: {
      title: '{{amount}} tilmeldingsbonus i appen',
      desc: 'Få {{amount}} i cashback, når du logger ind i vores app.',
    },
    welcome_bonus: {
      title: '{{amount}} velkomstbonus',
      desc: 'Få {{amount}} i cashback, når du registrerer dig.',
    },
  },
  discounts: {
    title: '{{discount}} rabat',
    usage_threshold: '(Min.: {{amount}})',
    description: {
      [PROMO_CODE_TYPES.ONE_TIME_PROMO_CODE]: '{{discount}} rabat på din næste bestilling - kode: {{code}}',
      [PROMO_CODE_TYPES.MULTI_PROMO_CODE]: '{{discount}} rabat på dine næste {{count}} bestillinger - kode: {{code}}',
    },
  },
  feedback: {
    login:
      '<highlight>Log ind</highlight> for at bruge denne kampagne, så vi kan sikre, at du ikke har brugt den før. Log ind, og prøv igen.',
  },
};
